import { useQuery } from 'query';
import type { PublicCommunityDataObject } from 'models/service';
import { getCommunityPublic } from '../services';
import { getCommunityPublicQueryKey } from './keys';

export const useCommunityPublicQuery = ({ communityId }: { communityId: string }) =>
  useQuery<PublicCommunityDataObject>({
    async queryFn() {
      const { data } = await getCommunityPublic({ routeParams: { id: communityId } });

      // TODO: we should return our model, but now is this used on old page, so we need to return data object
      return data;
    },
    queryKey: getCommunityPublicQueryKey({ id: communityId }),
  });
